import React, { useState, useEffect } from 'react'
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import moment from 'moment'
import { countryId } from '../../config/Constant';

const ButtonWrapper = (props) => {
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
    const detail = props.detail
    const feeDetail = props.feeDetail !==undefined && props.feeDetail
    const payType = props.payType
    const currency = props.currency

    const {installment_amount,installment_amount_local,installments_id,net_payable_amount,net_payable_amount_local,scholarship_amount,scholarship_amount_local,installments_number,total_fee_local,total_fee,scholarship_percentage,actual_inst_amt,actual_inst_amt_local,lumpsum_amount_local,lumpsum_amount}=feeDetail
    
    const amount = payType !== undefined && payType.value == 1 ? installment_amount_local? installment_amount_local:installment_amount : lumpsum_amount_local?lumpsum_amount_local:lumpsum_amount
    
    const default_amount = payType !== undefined && payType.value == 1 ? installment_amount :lumpsum_amount
    const amount_local = payType !== undefined && payType.value == 1 ? installment_amount_local : lumpsum_amount_local
   

    useEffect(() => {
        dispatch({
            type: "resetOptions",
            value: {
                ...options,
                currency: `${currency}`,

            },
        });
    }, [props.currency, props.feeDetail, props.detail, props.payType]);


    return (<>
        { (props.showSpinner && isPending) && <div className="spinner" /> }

        <PayPalButtons forceReRender={[amount, currency]}
            createOrder={(data, actions) => {
                
                return actions.order.create({
                    purchase_units: [
                        {
                            amount: {
                                currency_code: currency,
                                value: parseFloat(amount).toFixed(2) ,
                            },
                        },
                    ],
                    application_context: {
                        "brand_name": "Allen Overseas",
                        "shipping_preference": "NO_SHIPPING",
                        "user_action": "PAY_NOW",
                        "payment_method": {
                            "payee_preferred": "IMMEDIATE_PAYMENT_REQUIRED"
                        }
                    },
                    processing_instruction:"NO_INSTRUCTION"

                }).then((orderId) => {

                            return orderId;
                        });

            }}
            
            onApprove={(data, actions) => {
                return actions.order.capture().then((details) => {
                    const {purchase_units}=details
                    const{payments}=purchase_units[0]
                    const{captures}=payments

                    const name = details.payer.name.given_name;
                    const dataRes = {
                        student_id: detail.id,
                        amount: parseFloat(default_amount).toFixed(2),
                        local_amount: parseFloat(amount_local).toFixed(2),
                        pay_transaction_id: captures[0].id,
                        transaction_date: details.create_time,
                        payment_type: "Paypal",
                        payment_mode: "Online",
                        response: details,
                        scholarship_amount: scholarship_amount !==undefined && scholarship_amount,
                        local_scholarship_amount: scholarship_amount_local !==undefined && scholarship_amount_local ,
                        net_payable_amount: net_payable_amount !==undefined && net_payable_amount,
                        local_net_payable_amount: net_payable_amount_local !==undefined && net_payable_amount_local,
                        installments_id: installments_id !==undefined && installments_id,
                        scholarship_percentage: scholarship_percentage !==undefined && scholarship_percentage,
                        actual_inst_amt : actual_inst_amt !==undefined &&  actual_inst_amt,
                        local_actual_inst_amt : actual_inst_amt_local !==undefined && actual_inst_amt_local,
                        course_fee: total_fee !==undefined && total_fee,
                        local_course_fee: total_fee_local !==undefined && total_fee_local,
                        fee_type:payType.value,
                        transaction_status:details.status,
                        installments_number: feeDetail.installments_number,
                    }
                    props.onSubmit(dataRes)

                });
            }}
        />
    </>
    );
}

export default ButtonWrapper